import { EnvironmentSmataInfo } from './environment.model';

export const environment: EnvironmentSmataInfo = {
  name: 'Netstrata',
  production: true,
  envName: 'test',
  apiUrl: 'https://api.ss-edge-test.cloud.netstrata.com.au',
};
